import { Injectable } from '@angular/core';
import { ApiEffects } from '../../../utils/effects.util';
import { Actions } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { DateService } from '../../shared/services/date.service';
import { AccountsNotificationsService } from '../services/accounts-notifications.service';
import { getAutoPayActions } from './accounts-notifications.action';
import { selectAutoPay } from './accounts-notifications.selectors';

@Injectable()
export class AccountNotificationsEffects extends ApiEffects {
  constructor(
    readonly actions$: Actions,
    private readonly accountsNotificationsService: AccountsNotificationsService,
    private readonly dateService: DateService,
    private readonly store: Store
  ) {
    super(actions$);
  }

  getAutoPay$ = this.createCachedApiEffect({
    actions: getAutoPayActions,
    effectFn: (request) => this.accountsNotificationsService.getAutoPayResponse(request),
    cachedObservable: this.store.select(selectAutoPay),
  });
}
